module.exports = __webpack_public_path__ + "img/camera-logo.6f39d494.png";